module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.null_problem_list_show) ? _c('div', {
    staticClass: "example-problem"
  }, [_c('div', {
    staticClass: "example-problem-main"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "10%",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact_us')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t('faq_service')))]), _vm._v(" "), _vm._l((_vm.contace_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "contact_way pcShow"
    }, [_c('div', {
      staticClass: "contact_item1"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "width": "40"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "contact_item2"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.contact_tile)
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "contact_item3"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.contact_phone)
      }
    })])])
  }), _vm._v(" "), _vm._l((_vm.contace_list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "contact_way mobileShow"
    }, [_c('div', {
      staticClass: "contact_item1"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "width": "40"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "contact_item2"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.contact_tile)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.contact_phone)
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })], 2)]) : _c('div', {
    staticClass: "example-problem-group"
  }, [_c('h2', {
    staticClass: "example-problem-title"
  }, [_vm._v("\n            " + _vm._s(_vm.faqlist.now_title) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "Catalog_list"
  }, _vm._l((_vm.faqlist.table_of_contents), function(list, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      domProps: {
        "innerHTML": _vm._s(list.title)
      },
      on: {
        "click": function($event) {
          _vm.jump(index, 'list' + index)
        }
      }
    })])
  })), _vm._v(" "), _vm._l((_vm.problem_list), function(item, index, key) {
    return _c('div', {
      key: index,
      staticClass: "example-problem"
    }, [_c('div', {
      staticClass: "example-problem-main",
      attrs: {
        "id": 'list' + index
      }
    }, [_c('h2', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }, [_vm._v("Q:")]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ba45e77","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/ProblemList.vue
// module id = 823
// module chunks = 0